module.exports = __webpack_public_path__ + "img/base.6faa090f.jpg";